import { PhotoEvent } from 'common-models';
import { Model } from './Model';
import { EventWithSubEvents } from './types/EventWithSubEvents';

const getEventWithSubEvents = (event: PhotoEvent, allEvents: Array<PhotoEvent>): EventWithSubEvents => {
  return {
    event: Model.deepCopyEvent(event),
    subEvents: allEvents.filter((x) => x.parentEventId === event.id).map((x) => getEventWithSubEvents(x, allEvents)),
  };
};

export const getSortedEvents = (events: PhotoEvent[]) => {
  const result: Array<EventWithSubEvents> = [];
  const topLevelEvents = events.filter((x) => !x.parentEventId).map(Model.deepCopyEvent);

  for (let eventIndex = 0; eventIndex < topLevelEvents.length; eventIndex++) {
    const element = topLevelEvents[eventIndex];
    result.push(getEventWithSubEvents(element, events));
  }

  const sortedEvents = result.sort((a, b) => b.event.eventStartTime.valueOf() - a.event.eventStartTime.valueOf());
  return sortedEvents;
};
